import { atom } from 'recoil';

export const appointmentForState = atom({
  key: 'appointmentForState',
  default: 'patient',
});
